import { McqMaster } from './McqMaster.model';
import { ContentMaster } from './ContentMaster.model';
import { StudentLectureMaster } from './StudentLectureMaster.model';
import { MCQOptionMaster } from './MCQOptionMaster.model';

export class StudentLectureMcqMaster{
    public studentLectureMCQMasterId:number;
    public studentLectureMaster:StudentLectureMaster;
    public studentLectureMasterTemp:StudentLectureMaster;
    public mcqMaster:McqMaster;
    public answerContentMaster:MCQOptionMaster;
    public selectedAnswerContentMaster:MCQOptionMaster;
    public rightAnswerContentMaster:MCQOptionMaster;
    public wrongAnswerContentMaster:MCQOptionMaster;
    public answerContentMasterId:number;
    public isCompleted:Boolean;
    public isSkipped:Boolean;
    public attempts:number;
    public marks:number;
    public worngAnswers:String;
    public errorMessage:String;
    public pageNumber:number;
    public pageSize:number;
    public randomList:Boolean;
}
